import { Icon, ICONS, isServer, Tooltip } from '@bob/library'
import { copyToClipboard } from '@websrc/App/Helpers/copyToClipboard'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { button } from 'leds'
import React, { FC } from 'react'

export type CopyToClipboardProps = {
  id: string
  tooltipText?: string
}

export const CopyToClipboard: FC<CopyToClipboardProps> = ({ id, tooltipText }) => {
  const t = useStaticText()
  const url = isServer ? `#${id}` : `${window.location.origin}${window.location.pathname}#${id}`

  return (
    <Tooltip
      content={tooltipText ?? t.print_and_share.copy_button}
      id={`copy ${id} to clipboard`}
      position={'right'}
    >
      <button className={button({ type: 'icon' })} onClick={() => void copyToClipboard(url)}>
        <Icon icon={{ ...ICONS.LINK, title: t.print_and_share.copy_button }} size={17} />
      </button>
    </Tooltip>
  )
}
